<template>
  <div>
    <el-card>
      <!--基础信息-->
      <div style="font-size: 14px; color: #606266;">
        <span>No：{{ formData.resNo }}</span>
        <el-divider direction="vertical"></el-divider>
        <span>Status：{{ formData.resStatusName }}</span>
        <el-divider direction="vertical"></el-divider>
        <span
          >Create：{{ formData.createByName }} at
          {{ formData.createDate }}</span
        >
        <el-divider direction="vertical"></el-divider>
        <span
          >Modify：{{ formData.modifyByName }} at
          {{ formData.modifyDate }}</span
        >
      </div>
      <div class="d2-mt">
        <el-form ref="form" :model="formData" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="14">
              <el-form-item
                :label="$l('form_label_name_cn') || '中文名称'"
                prop="resName"
              >
                <el-input
                  :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                  maxlength="4000"
                  v-model="formData.resName"
                  clearable
                  size="medium"
                  :disabled="isViewDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$l('form_label_name_en') || '英文名称'"
                prop="resNameEn"
              >
                <el-input
                  :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                  maxlength="4000"
                  v-model="formData.resNameEn"
                  clearable
                  size="medium"
                  :disabled="isViewDisabled"
                ></el-input>
              </el-form-item>
              <el-row :gutter="15">
                <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
                  <el-form-item
                    :label="$l('form_label_marketArea') || '市场地区'"
                    prop="marketRegion"
                  >
                    <dict-select
                      :disabled="isViewDisabled"
                      clearable
                      filterable
                      style="width:100%;"
                      v-model="formData.marketRegion"
                      size="medium"
                      url="/digitalCenter/common/dict/system"
                      :placeholder="
                        $l('INDEX.tips_select_placeholder') || '请选择'
                      "
                      :body="{ dictType: 'marketRegion' }"
                    ></dict-select>
                  </el-form-item>
                </el-col>
                <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
                  <el-form-item
                    :label="$l('form_label_yearOfSale') || '销售年份'"
                    prop="saleYear"
                  >
                    <el-date-picker
                      :disabled="isViewDisabled"
                      v-model="formData.saleYear"
                      type="year"
                      :placeholder="
                        $l('INDEX.tips_select_placeholder') || '请选择'
                      "
                      value-format="yyyy"
                      size="medium"
                      style="width:100%;"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col
                  :sm="{ span: 20 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 12 }"
                >
                  <el-form-item
                    :label="$l('form_label_salesSeason') || '销售季节'"
                    prop="saleSeason"
                  >
                    <el-input
                      maxlength="50"
                      v-model="formData.saleSeason"
                      clearable
                      size="medium"
                      :placeholder="
                        $l('INDEX.tips_input_placeholder') || '请输入'
                      "
                      :disabled="isViewDisabled"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="15">
                <el-col
                  :sm="{ span: 20 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 12 }"
                >
                  <el-form-item
                    :label="$l('form_label_brand') || '品牌'"
                    prop="brand"
                  >
                    <el-input
                      maxlength="50"
                      v-model="formData.brand"
                      clearable
                      size="medium"
                      :placeholder="
                        $l('INDEX.tips_input_placeholder') || '请输入'
                      "
                      :disabled="isViewDisabled"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :sm="{ span: 20 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 12 }"
                >
                  <el-form-item
                    :label="$l('form_label_store') || '门店'"
                    prop="storeName"
                  >
                    <el-input
                      maxlength="100"
                      v-model="formData.storeName"
                      clearable
                      size="medium"
                      :placeholder="
                        $l('INDEX.tips_input_placeholder') || '请输入'
                      "
                      :disabled="isViewDisabled"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="15">
                <el-col
                  :sm="{ span: 20 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 12 }"
                >
                  <el-form-item
                    :label="$l('form_label_RMBPrice') || '人民币售价'"
                    prop="rmbSalePrice"
                  >
                    <el-input
                      maxlength="11"
                      v-model="formData.rmbSalePrice"
                      clearable
                      size="medium"
                      :placeholder="
                        $l('INDEX.tips_input_placeholder') || '请输入'
                      "
                      :disabled="isViewDisabled"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="{ span: 20 }" :md="{ span: 8 }" :lg="{ span: 8 }">
                  <el-form-item
                    :label="$l('form_label_regionalSellingPrice') || '区域售价'"
                    prop="regionSalePrice"
                  >
                    <el-input
                      maxlength="11"
                      v-model="formData.regionSalePrice"
                      clearable
                      size="medium"
                      :placeholder="
                        $l('INDEX.tips_input_placeholder') || '请输入'
                      "
                      :disabled="isViewDisabled"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="{ span: 20 }" :md="{ span: 4 }" :lg="{ span: 4 }">
                  <el-form-item
                    :label="$l('form_label_currency') || '币种'"
                    prop="currency"
                  >
                    <dict-select
                      :disabled="isViewDisabled"
                      clearable
                      filterable
                      style="width:100%;"
                      v-model="formData.currency"
                      size="medium"
                      url="/digitalCenter/common/dict/system"
                      :placeholder="
                        $l('INDEX.tips_select_placeholder') || '请选择'
                      "
                      :body="{ dictType: 'currency' }"
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item
                :label="$l('form_label_fabricComposition') || '面料构成'"
                prop="composition"
              >
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 6 }"
                  maxlength="1000"
                  v-model="formData.composition"
                  clearable
                  size="medium"
                  :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                  :disabled="isViewDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$l('form_label_remarks') || '备注说明'"
                prop="resMemo"
              >
                <el-input
                  :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 6 }"
                  maxlength="200"
                  v-model="formData.resMemo"
                  clearable
                  size="medium"
                  :disabled="isViewDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$l('form_label_category') || '所属分类'"
                prop="categoryCode"
              >
                <dict-select
                  style="width: 100%"
                  size="medium"
                  v-model="formData.categoryCode"
                  url="/digitalCenter/common/dict/masterCategory"
                  :disabled="isViewDisabled"
                  clearable
                  filterable
                  :body="{ parentCode: 0 }"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-row>
                <el-col
                  :sm="{ span: 20 }"
                  :md="{ span: 10 }"
                  :lg="{ span: 10 }"
                >
                  <uploader-image
                    :multiple="false"
                    :thumbnail="{ quality: 0.2 }"
                    :on-added="onAdded"
                    :data="{
                      url: $osscdn(formData.resImageCode),
                      turl: $osscdn(formData.resThumbImageCode),
                    }"
                  ></uploader-image>
                </el-col>
                <el-col :span="4" style="text-align: center">
                  <i
                    class="el-icon-right icon-right"
                    style="width:180px;height:10px;"
                    v-show="false"
                  ></i>
                </el-col>
              </el-row>
              <el-row style="margin-top: 50px;">
                <el-col
                  :sm="{ span: 24 }"
                  :md="{ span: 24 }"
                  :lg="{ span: 24 }"
                >
                  <info-image ref="image" :resCode="resCode"></info-image>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-row>
        <info-attribute
          size="medium"
          :span="14"
          :disabled="isViewDisabled"
          ref="attribute"
          :params="attrParams"
        ></info-attribute>
      </el-row>
      <el-row style="margin-top: 20px;">
        <el-col :span="24">
          <el-button
            @click="save"
            type="primary"
            size="small"
            v-if="!isViewDisabled"
            >{{ $l('form_button_save') || '保存' }}</el-button
          >
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import util from '@/libs/util'
import InfoImage from './components/image'
import InfoAttribute from '@/views/digital/components/attribute'
import validate from '@/libs/util.validate'
import { mapActions } from 'vuex'
export default {
  components: {
    InfoImage,
    InfoAttribute,
  },
  computed: {
    attrParams() {
      return {
        infoCode: this.formData.resCode,
        templateCategoryCode: this.formData.categoryCode,
        masterCategoryCode: this.formData.categoryCode,
        templateType: 'R',
      }
    },
  },
  data() {
    let reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/ // 验证金额
    let checkRmbSalePrice = (rule, value, callback) => {
      if (this.formData.rmbSalePrice && !reg.test(value)) {
        callback(
          new Error(
            this.$l('form_rule_message_price') || '价格为正整数或保留1到2位小数'
          )
        )
      }
      callback()
    }
    let checkRegionSalePrice = (rule, value, callback) => {
      if (this.formData.regionSalePrice && !reg.test(value)) {
        callback(
          new Error(
            this.$l('form_rule_message_price') || '价格为正整数或保留1到2位小数'
          )
        )
      }
      callback()
    }
    return {
      pageHeader: '',
      isViewDisabled: false,
      dialogVisible: false,
      activeName: 'basic',
      fileData: {
        // 文件上传参数
        expirationsec: 0,
        fileproperty: 'publicfiles',
      },
      fileHeaders: {
        // 文件上传请求头
        tokenTimeOut: 0,
        token: util.token.getToken(),
      },
      resCode: '',
      itemTagList: ['夹克', '加绒', '短款'],
      itemAttributeList: ['属性1', '属性2', '属性3'],
      formData: {
        resCode: '',
        resNo: '',
        resName: '',
        resNameEn: '',
        marketRegion: '',
        brand: '',
        storeName: '',
        saleYear: '',
        saleSeason: '',
        rmbSalePrice: '',
        regionSalePrice: '',
        currency: '',
        composition: '',
        categoryCode: '',
        resImageCode: '',
        resImageUrl: '',
        resThumbImageCode: '',
        resThumbImageUrl: '',
        resMemo: '',
        resStatus: 'Y',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: '',
      },
      rules: {
        rmbSalePrice: [
          { required: false, validator: checkRmbSalePrice, trigger: 'blur' },
        ],
        regionSalePrice: [
          { required: false, validator: checkRegionSalePrice, trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    let type = this.$route.params.pageType
    let resCode = this.$route.params.resCode
    this.init(type, resCode)
  },
  activated() {
    let type = this.$route.params.pageType
    let resCode = this.$route.params.resCode
    this.init(type, resCode)
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    onAdded({ md5, isThumb, suffix }) {
      let code = md5 + '.' + suffix
      if (isThumb) {
        this.formData.resImageCode = code
      } else {
        this.formData.resThumbImageCode = code
      }
    },
    init(type, resCode) {
      this.resCode = resCode
      if (type === 'edit') {
        this.updateLoad(resCode)
        this.$refs['image'].init(type, resCode)
      } else if (type === 'detail') {
        this.detailLoad(resCode)
        this.$refs['image'].init(type, resCode)
      } else {
        this.addLoad(resCode)
      }
    },
    save() {
      this.saveData()
    },
    // 保存数据
    saveData() {
      const form = this.$refs.form
      const attrForm = this.$refs.attribute.$refs.form
      validate.formValidate([form, attrForm], (valid) => {
        if (valid) {
          this.formData.attrData = this.$refs.attribute.getFormData()
          if (this.formData.resCode) {
            this.formData.attrData.infoCode = this.formData.resCode
          }
          this.formData.attrData.templateCategoryCode = this.formData.categoryCode
          this.$api.saveResearchInfoApi(this.formData).then(() => {
            this.saveOkQuestion()
          })
        }
      })
    },
    detailLoad(val) {
      this.pageHeader = this.$l('page_header_title_3') || '市场情报详情'
      this.isViewDisabled = true
      let param = { resCode: val }
      this.$api.detailResearchInfoApi(param).then((res) => {
        this.formData = res.body
        if (this.formData.resStatus === 'Y') {
          this.formData.resStatusName = '有效'
        } else {
          this.formData.resStatusName = '无效'
        }
        this.$refs.attribute.load(this.attrParams)
      })
    },
    addLoad(val) {
      this.isViewDisabled = false
      this.pageHeader = this.$l('page_header_title_2') || '市场情报添加'
      // this.formData.categoryCode = val.split('=')[0]
      this.resCode = ''
      this.$refs.attribute.load(this.attrParams)
      this.formData.resStatusName = '有效'
      this.$refs['image'].init('add', '')
    },
    updateLoad(val) {
      this.pageHeader = this.$l('page_header_title_1') || '市场情报修改'
      this.isViewDisabled = false
      let param = { resCode: val }
      this.$api.detailResearchInfoApi(param).then((res) => {
        this.formData = res.body
        if (this.formData.resStatus === 'Y') {
          this.formData.resStatusName = '有效'
        } else {
          this.formData.resStatusName = '无效'
        }
        this.$refs.attribute.load(this.attrParams)
      })
    },
    handleTagClose(tag) {
      this.itemTagList.splice(this.itemTagList.indexOf(tag), 1)
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_save_ok') || '保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    reset() {
      this.dialogVisible = false
      this.formData.resCode = ''
      this.formData = {
        resCode: '',
        resNo: '',
        resName: '',
        resNameEn: '',
        marketRegion: '',
        brand: '',
        storeName: '',
        saleYear: '',
        saleSeason: '',
        rmbSalePrice: '',
        regionSalePrice: '',
        currency: '',
        composition: '',
        categoryCode: '',
        resImageCode: '',
        resImageUrl: '',
        resThumbImageCode: '',
        resThumbImageUrl: '',
        resMemo: '',
        resStatus: 'Y',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: '',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}

.text-annotation {
  color: $color-primary;
  font-size: 13px;
}

.avatar-uploader {
  i {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border-color: #409eff;
    }
  }
}

.icon-right {
  font-size: 28px;
  color: #8c939d;
  width: 220px;
  height: 220px;
  line-height: 220px !important;
  text-align: center;
}

.events-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 220px !important;
  height: 220px;
  line-height: 220px !important;
  text-align: center;
}

.events-uploader-icon-small {
  font-size: 28px;
  color: #8c939d;
  width: 100px !important;
  height: 100px;
  line-height: 100px !important;
  text-align: center;
}

.events {
  width: 220px !important;
  height: 220px;
  display: block;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
